import $ from 'jquery';

$.addInit(function(context){
	var base = '.i-cookieDialog';

	function hasCookie(cookie) {
		return new RegExp('(^|; )' + cookie + '=').test(document.cookie);
	}
	
	function setCookie(cookie, value, days) {
		var cookieExpires = new Date();
		cookieExpires.setDate(cookieExpires.getDate() + days);
		document.cookie = encodeURIComponent(cookie) + '=' + encodeURIComponent(value) + ';path=/;expires=' + cookieExpires.toUTCString();
	}

	$(base, context).each(function(){
		var component = $(this);

		if (!hasCookie('cookie-accept')) {
			component.show();
			component.find('.i-cookieDialog-close').on('click', function(e){
				e.preventDefault();
				component.hide();
				setCookie('cookie-accept', 1, 365);
			});
		}
	});
});